import { useCallback } from "react";
import { Button, Col, FormFeedback, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Form } from "reactstrap";
import { Toggleable } from "../../../../hook/useToggle";
import { Action } from "../../../../types/reducer-action";
import { trimToEmpty } from "../../../../utils/commons";
import BusyButton from "../../../common/busy-button";
import { DataEntryEvent, FormUpdateAction } from "../../../common/data-entry-reducer";
import { AddIcon, CloseIcon } from "../../../common/icons";
import Textarea from "../../../common/textarea/textarea";
import useUserApi from "../useUserApi";
import { UserManagerDomain, useUserDispatch, useUserState } from "../user-manager-context";

const NewMemoModal = (props: Toggleable) => {
  const { isOpen, toggle } = props;

  const { dataDetails: userDetails, subdomains } = useUserState();
  const dispatch = useUserDispatch();

  const { [UserManagerDomain.Memos]: memoState } = subdomains;

  const { form, errors = {} } = memoState ?? {};

  const { createUserMemo, busy } = useUserApi();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) =>
    dispatch(new FormUpdateAction(event, UserManagerDomain.Memos));

  const handleSubmit = useCallback(() => {
    if (!userDetails?.id) return;

    const memoTxt = trimToEmpty(form?.memoTxt);
    if (!memoTxt) {
      dispatch(new Action(UserManagerDomain.Memos + DataEntryEvent.AddErrors,
        { memoTxt: 'Memo text cannot be empty.' }
      ));
    } else {
      createUserMemo(userDetails.id, memoTxt)
        .then(ok => ok && toggle());
    }
  }, [userDetails, form]);

  return (
    <Modal isOpen={isOpen} toggle={toggle} backdrop="static" size="lg" scrollable autoFocus={false}>
      <ModalHeader toggle={toggle} tag={'h2'}>Create New Memo</ModalHeader>
      <ModalBody>
        <Form id="new_memo_form" onSubmit={handleSubmit} className="oms-container">
          <FormGroup row>
            <Label for="memo_text" className="col-auto col-form-label">New Memo Text:</Label>
            <Col>
              <Textarea
                id="memo_text"
                name="memoTxt"
                aria-label="Memo text"
                rows={4}
                placeholder="Enter a Memo"
                value={form?.memoTxt}
                onChange={handleChange}
                maxLength={1000}
                required
                invalid={!!errors.memoTxt}
                autoFocus={true}
                />
              <FormFeedback>{errors.memoTxt}</FormFeedback>
            </Col>
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <BusyButton form="new_memo_form" type="submit"
          aria-label="Create" color="primary"
          value="Create" busy={busy}>
          <AddIcon />
        </BusyButton>

        <Button color="secondary" onClick={toggle} disabled={busy}>
          <CloseIcon /> Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewMemoModal;
